import {
  MenuComponent,
  PushNotificationComponent,
  SocketComponent
} from '@rededor/ap-core-frontend-react'
import { isValid } from 'date-fns'

import { getAccessToken } from '@/utils/helpers/storageHelpers'
import { appSettings } from '@/shared/consts/appSettings'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useFeaturesFlagsContext } from '@rededor/ap-shared-components-frontend'

export const AppHeader = () => {
  const { push, messenger } = useFeaturesFlagsContext()
  const accessToken = getAccessToken()
  const hasConfirmedSchedule = useScheduleStore((s) => s.hasConfirmedSchedule)

  const product = useScheduleStore((s) => s.product)
  const location = useScheduleStore((s) => s.location)
  const patient = useScheduleStore((s) => s.patient)
  const doctor = useScheduleStore((s) => s.doctor)
  const healthPlan = useScheduleStore((s) => s.healthPlan)
  const documentIds = useScheduleStore((s) => s.documentIds)

  const url = new URL(appSettings.publicUrl, window.location.origin)
  const urlWithParams = new URL(url)

  const birthDate =
    patient?.birthDate &&
    isValid(new Date(patient.birthDate)) &&
    new Date(patient.birthDate).toISOString()

  const params = {
    especialidadem: product?.idMotion?.toString(),
    local: location?.id?.toString(),
    pacienteDataNascimento: birthDate,
    pacienteGenero: patient?.gender,
    medicom: doctor?.id?.toString(),
    planordsl: healthPlan?.id?.toString(),
    healthCardNumber: healthPlan?.cardNumber,
    documentIds
  }

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      urlWithParams.searchParams.set(key, String(value))
    }
  }

  const redirectUrl = hasConfirmedSchedule ? url.href : urlWithParams.href

  return (
    <>
      <PushNotificationComponent
        application={appSettings.applicationName}
        clientId={appSettings.patientArea.clientId}
        accessToken={accessToken}
        baseUrl={appSettings.patientArea.baseUrl}
        activateNotification={!!push}
      />
      <SocketComponent
        application={appSettings.applicationName}
        clientId={appSettings.patientArea.clientId}
        accessToken={accessToken}
        baseUrl={appSettings.patientArea.baseUrl}
        activateNotification={!!messenger}
      >
        <MenuComponent
          isAuthenticated={Boolean(accessToken)}
          accessToken={accessToken}
          application={appSettings.applicationName}
          clientId={appSettings.patientArea.clientId}
          redirectOnLogin={redirectUrl}
          redirectOnLogout={url.href}
          redirectOnProfile={redirectUrl}
          baseUrl={appSettings.patientArea.baseUrl}
          activateNotificationFeatureFlag={!!messenger}
        />
      </SocketComponent>
    </>
  )
}
